import axios, { AxiosResponse } from "axios";

import { UPDATESURL, DOMIAN } from "../../shared/constants";
import { IAdminLogin } from "../../shared/dtos";
import { getCookie } from "./cookies";
import { removeAllCookies } from "../BankUpdate/cookies";

const axiosInterceptor = axios.create({
  baseURL: UPDATESURL,
});

axiosInterceptor.interceptors.request.use(
  async (req) => {
    const token = getCookie("access_token");
    const userid = getCookie("userId");
    const deviceId = getCookie("deviceId");
    const source = getCookie("source") ? getCookie("source") : "WEB";

    req.headers.Authorization = `userId=${userid};deviceId=${deviceId};source=${source};finupdate_token=${token}`;
    return req;
  },
  (error) => Promise.reject(error)
);

axiosInterceptor.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      handleLogout();
    }
    return Promise.reject(err);
  }
);
const handleLogout = () => {
  removeAllCookies();
  setTimeout(() => {
    window.location.href = "/";
  }, 100);
};

export const GetFirstTimeLoginAPICall = (userId: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/V1/firstTimeLogin/${userId}`, {
        // params: {
        //   userId: userId,
        // },
      })
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetModificationrequestsFinUpdateAPICalls = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/financial_update/get_modification_request`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetFinDetailsAPICalls = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/financial_update/get_financial_details`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetIncomeSlabAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/common/income_slab`, { params: requestBody })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetIncomeProofAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/common/income_proof`, { params: requestBody })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const SubmitDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/financial_update/submit_details`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const stageDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/financial_update/stage_details`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const deleteDocumentAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .delete(`/v1/api/financial_update/documents/delete`, {
        data: {
          // client_code: requestBody.client_code,
          document_purpose: requestBody.document_purpose,
          request_id: requestBody.request_id,
        },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const uploadDocumentsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/financial_update/documents/upload`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const AdminLoginToClientAccountAPICall = (requestBody: IAdminLogin) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/rekyc/admin_login/`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const FinUpdateAccountAggregatorFetchDataFinupdateAPICall = (
  requestBody: any
) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(
        // `/v1/api/financial_update/stage/account_aggregator/fetch_data/`,
        `/v1/api/financial_update/cams_aa/fetch_data/`,
        requestBody,
        {}
      )
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const FinUpdateAccountAggregatorCreateConsentAPICall = (
  requestBody: any
) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(
        // `/v1/api/financial_update/stage/account_aggregator/create_consent/`,
        `/v1/api/financial_update/cams_aa/create_consent/`,
        requestBody,
        {}
      )
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
